// dina rules the school

//███████╗██╗░░██╗██████╗░███████╗███╗░░██╗░██████╗██╗██╗░░░██╗███████╗  ███╗░░░███╗░█████╗░██████╗░███████╗
//██╔════╝╚██╗██╔╝██╔══██╗██╔════╝████╗░██║██╔════╝██║██║░░░██║██╔════╝  ████╗░████║██╔══██╗██╔══██╗██╔════╝
//█████╗░░░╚███╔╝░██████╔╝█████╗░░██╔██╗██║╚█████╗░██║╚██╗░██╔╝█████╗░░  ██╔████╔██║██║░░██║██║░░██║█████╗░░
//██╔══╝░░░██╔██╗░██╔═══╝░██╔══╝░░██║╚████║░╚═══██╗██║░╚████╔╝░██╔══╝░░  ██║╚██╔╝██║██║░░██║██║░░██║██╔══╝░░
//███████╗██╔╝╚██╗██║░░░░░███████╗██║░╚███║██████╔╝██║░░╚██╔╝░░███████╗  ██║░╚═╝░██║╚█████╔╝██████╔╝███████╗
//╚══════╝╚═╝░░╚═╝╚═╝░░░░░╚══════╝╚═╝░░╚══╝╚═════╝░╚═╝░░░╚═╝░░░╚══════╝  ╚═╝░░░░░╚═╝░╚════╝░╚═════╝░╚══════╝

if (sessionStorage['expensive-mode'] == 'on') { $('body').addClass('expensive').removeClass('nothing');}
else {$('body').removeClass('nothing');}

// RAISE PRICES
function raisePrices() {

    // change prices
    $('body.expensive [data-price]:not(.raised),body.expensive .product-item__price:not(.raised)').each(function(){

      if(!$(this).find('.sale')[0]) {      
        var thisprice = $(this).text().replace(',','').split('.')[0];
        var newprice = thisprice+'0.00';
        var newnewprice = newprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        $(this).text(newnewprice).addClass('raised');
      } // end if no sale price

      // check for sale
      if($(this).find('.sale')[0]) {  // above data-price already got it
        $('.sale.raised').parent().addClass('raised');
      } // end if sale price      
      
    }); // end each

     // check recommended products
    var checkrecprod = setInterval(function(){      
     if ($('.recommended-products__content .product-item__price')[0]) {
        $('.recommended-products__content .product-item__price:not(.raised), .recommended-products__content [data-price]:not(.raised)').each(function(){

          // check for sale
          if($(this).find('.sale')[0]) {  // above data-price already got it
          } // end if sale price

          if(!$(this).find('.sale')[0]) {
              var thisprice = $(this).text().replace(',','').split('.')[0];
              var newprice = thisprice+'0.00';
              var newnewprice = newprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              $(this).text(newnewprice).addClass('raised');
          } // end if no sale price
          
        }); // end each
        clearInterval(checkrecprod);
      } // end recommended products
    },300);
  
}

//document.addEventListener('DOMContentLoaded', function() {

// KEEP TURNED ON
if (sessionStorage['expensive-mode'] == 'on') { 

    //$('body').addClass('expensive'); // added to header to speed up
    $('.toggle-btn').removeAttr('off').attr('on','');  

    // TURN ON EXPENSIVE MODE
    //console.log('its still expensive mode');

    raisePrices();  

    // button text
    $('.expensive-mode-label').text('Expensive Mode™ On');
    //$('.expensive-mode-label').text('Rich Slut Mode™ On');

    // headers
    $('body').prepend("<youarerich><messages><span>$$ You are shopping in Expensive Mode™ $$</span><span>$$ Wow you're so rich $$</span><span>$$ Expensive Mode is ON - You're worth it! $$</span></messages><div class='toggle-btn banner' on title='Are you rich?'><input type='checkbox' id='toggle-btn-1'><label for='toggle-btn-1'></label><div class='expensive-mode-label'><mode>Expensive Mode™ </mode>On</div></div></youarerich>");
    //$('body').prepend("<youarerich><messages><span>$$ You are shopping in Rich Slut Mode™ $$</span><span>$$ Wow you're so rich $$</span><span>$$ Rich Slut Mode is ON - You're worth it! $$</span></messages><div class='toggle-btn banner' on title='Are you rich?'><input type='checkbox' id='toggle-btn-1'><label for='toggle-btn-1'></label><div class='expensive-mode-label'><mode>Rich Slut Mode™ </mode>On</div></div></youarerich>");
    var youarerichHeight = $('youarerich').outerHeight();
    $('body').css('padding-top', youarerichHeight + 10 +'px');
    $('body.expensive .header-space').css('height','calc(var(--announcement-height) + (calc(var(--header-desktop-sticky-position) * -1) +'+youarerichHeight+')');
    $('div.announcement-bar__item-inner p').text('Free Shipping Worldwide on Orders over $2,000');  

} // end if still in expensive mode

//}, false); // end event listener

// LABEL MOBILE/DESKTOP
$('div.header__row-segment-desktop .toggle-btn').addClass('desktop');
$('div.header__row-mobile .toggle-btn').addClass('mobile');


$(document).on('click','.toggle-btn',function(){

    // TURN ON EXPENSIVE MODE
    if ($('.toggle-btn[off]')[0]) {
    //console.log('checked');
    sessionStorage.setItem('expensive-mode','on');

    $('body').addClass('expensive');
    $('.toggle-btn').removeAttr('off').attr('on','');
      
    raisePrices();

    // button text
    $('.expensive-mode-label').text('Expensive Mode™ On');
    //$('.expensive-mode-label').text('Rich Slut Mode™ On');

    // headers
    $('body').prepend("<youarerich><messages><span>$$ You are shopping in Expensive Mode™ $$</span><span>$$ Wow you're so rich $$</span><span>$$ Expensive Mode is ON - You're worth it! $$</span></messages><div class='toggle-btn banner' on title='Are you rich?'><input type='checkbox' id='toggle-btn-1'><label for='toggle-btn-1'></label><div class='expensive-mode-label'><mode>Expensive Mode™ </mode>On</div></div></youarerich>");
    //$('body').prepend("<youarerich><messages><span>$$ You are shopping in Rich Slut Mode™ $$</span><span>$$ Wow you're so rich $$</span><span>$$ Rich Slut Mode is ON - You're worth it! $$</span></messages><div class='toggle-btn banner' on title='Are you rich?'><input type='checkbox' id='toggle-btn-1'><label for='toggle-btn-1'></label><div class='expensive-mode-label'><mode>Rich Slut Mode™ </mode>On</div></div></youarerich>");
    var youarerichHeight = $('youarerich').outerHeight();
    $('body').css('padding-top', youarerichHeight + 10 +'px');
    $('body.expensive .header-space').css('height','calc(var(--announcement-height) + (calc(var(--header-desktop-sticky-position) * -1) +'+youarerichHeight+')');
    $('div.announcement-bar__item-inner p').text('Free Shipping Worldwide on Orders over $2,000');

    // cart
    window.upcartOnCartLoaded = function() {
      if ($('body.expensive .upcart-footer')[0]) {
        if (!$('.upcart-footer disclaimer').length) {
          $('.upcart-footer').prepend("<disclaimer><strong>Expensive Mode™ Disclaimer</strong><br>Expensive Mode™ is not real. Your cart reflects accurate pricing. Since you have extra money to burn here are two charities we encourage you to donate to <charities><a href='https://www.pcrf.net/' target='blank'>Palestine Children's Relief Fund</a> & <a href='https://wrrap.org/' target='blank'>Women’s Reproductive Rights Assistance Project</a></charities></disclaimer>")
          //$('.upcart-footer').prepend("<disclaimer><strong>Rich Slut Mode™ Disclaimer</strong><br>Rich Slut Mode™ is not real. Your cart reflects accurate pricing. Since you have extra money to burn here are two charities we encourage you to donate to <charities><a href='https://www.pcrf.net/' target='blank'>Palestine Children's Relief Fund</a> & <a href='https://wrrap.org/' target='blank'>Women’s Reproductive Rights Assistance Project</a></charities></disclaimer>")
        } // end if disclaimer isn't there
      } // end if footer is open
    }
    return false; // end check cart

      
  }

  // TURN OFF EXPENSIVE MODE
  
  if ($('.toggle-btn[on]')[0]) {
    sessionStorage.setItem('expensive-mode',null);

    $('body').removeClass('expensive');
    
    $('.toggle-btn').removeAttr('on').attr('off','');
    
    // change prices
    $('.product-item__price, span[data-price]').each(function(){

     // check for sale
      if($(this).find('.sale')[0]) {  // above data-price already got it
      } // end if sale price
  
      if(!$(this).find('.sale')[0]) {
      var thisprice = $(this).text().replace(',','').split('0.00')[0];
      var newprice = thisprice + '.00';
      var newnewprice = newprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $(this).text(newnewprice).removeClass('raised');
      } // end if no sale price

    }); // end each price

    // button text
    $('.expensive-mode-label').text('Expensive Mode™ Off');

    // headers
    $('youarerich, disclaimer').remove();
    $('body').css('padding-top','0px');
    $('div.announcement-bar__item-inner p').text('Free Shipping Worldwide on Orders over $200');
    return false;
  }  
}) // end click toggle button

// fix price for size selection
$(document).on('click','body.expensive div.product__variants-wrapper button',function(){
  //console.log('size');
  $('[data-price]').each(function(){
      var thisprice = $(this).text().replace(',','').split('.')[0];
      var newprice = thisprice+'0.00';
      var newnewprice = newprice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      $(this).text(newnewprice);
  })
})

// FIX PRICES ON SORT

// desktop sort
$('body:not(.is-mobile) .filter-group__list--sort input:not([checked])').on( "click", function() { 

    $('body').attr('sorting','');
    console.log('clicked');
    i=1;
  
    var fixSorted = setInterval(function(){

      i++;console.log(i);

      // if it finishes loading
      if ($('.collection__loading:not(.is-active)')[0]) {
        raisePrices();
        console.log('finished loading');   
        setTimeout(function(){
          console.log('clear interval');
          clearInterval(fixSorted);
          $('body').removeAttr('sorting');
        },5000);
      } // end if loading is done

      // stop fixing when sort dropdown is hidden
      //if ($('#filter-bar-sort[aria-hidden=true]')[0]) {clearInterval(fixSorted);}
    
    },10); // end fixSorted interval
  
}) // end clicked sort button

// mobile sort
$(document).on('click','body.is-mobile .mobile-filters', function(){

  //console.log('clicked');
  //i=0
  
  var fixSorted = setInterval(function(){
      //i++;console.log(i);
      if ($('.collection__loading:not(.is-active)')[0]) {
        raisePrices();
        console.log('finished loading');   
        setTimeout(function(){
          console.log('clear interval');
          clearInterval(fixSorted);
          $('body').removeAttr('sorting');
        },5000);
      } // end if loading is done
    
  },100) // end fixSorted interval  

  
}) // end clicked sort button

// move toggle to banner on scroll down
$(window).scroll(function(){
  var vizzy = $('body.expensive .icon-header-search:visible').visible( false, true );
  if (vizzy == false) {
    $('.toggle-btn:not(.banner)').hide();
    $('.toggle-btn.banner').show();
  } else { 
    $('.toggle-btn:not(.banner)').show();
    $('.toggle-btn.banner').hide();
  }
});

 // ██╗░░░██╗
 // ╚██╗░██╔╝
 // ░╚████╔╝░
 // ░░╚██╔╝░░
 // ░░░██║░░░
 // ░░░╚═╝░░░
  
if (window.matchMedia('(min-width: 327px)').matches) {  // if bigger than 327px
  if ($('body.template-index')[0]) {
    var logo = $('body.template-index div.regular-logo img').attr('srcset');
    var newLogo = logo.replace(/black.png/g, 'black-noy.png');
    $('body.template-index div.regular-logo img').attr('srcset',newLogo);
    $('body.template-index div.regular-logo').append('<y class="grow" title="help me">y</y>');   
  } // end if index page
} // end if bigger than 327px


//  ░██████╗███████╗░█████╗░██████╗░░█████╗░██╗░░██╗
//  ██╔════╝██╔════╝██╔══██╗██╔══██╗██╔══██╗██║░░██║
//  ╚█████╗░█████╗░░███████║██████╔╝██║░░╚═╝███████║
//  ░╚═══██╗██╔══╝░░██╔══██║██╔══██╗██║░░██╗██╔══██║
//  ██████╔╝███████╗██║░░██║██║░░██║╚█████╔╝██║░░██║
//  ╚═════╝░╚══════╝╚═╝░░╚═╝╚═╝░░╚═╝░╚════╝░╚═╝░░╚═╝
  $('input#search').keyup(function() {
    
      var search = $('input#search').val();
  
      // when search empties
      if( !$('input#search').val() ) { 
        $('crack').remove();
      } 
      
      else {

        // AMC
        if (search.indexOf("amc") >= 0) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              //if (search.length >=4 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>Don’t know what you’re talking about</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END AMC

        // CHEESE
        else if (search.indexOf("cheese") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>Welcome mouse.</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END CHEESE

        // DADDY
        else if (search.indexOf("daddy") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>Excuse me this is a fashion brand.</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END DADDY       
        
        // DRESS
        else if (search.indexOf("dress") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>“No results for dress” just kidding here they are.</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END DRESS
        
        // JEANS
        else if (search.indexOf("jeans") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>Do you have a license for that dump truck?</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END JEANS        
        
        // MOTH
        else if (search.indexOf("moth") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>Wow you have really bad taste.</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END IF MOTH
  
        // MYSTERY
        else if (search.indexOf("mystery") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>Search and you will not find.</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END MYSTERY

        // SALE
        else if (search.indexOf("sale") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>What’s this ABOUT?</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END SALE       

        // URN
        else if (search.indexOf("urn") >= 0 && !$('.quick-search__no-results-header')[0]) {
          if ($('form.quick-search__form crack')[0]) { // if it's already there
          var target = document.querySelector('div.quick-search__results')
          var observer = new MutationObserver(function(mutations) {
              if (target.innerText.indexOf('No results for') >=0 ) {$('crack').remove();}
          });
          observer.observe(target, {attributes:true, childList:true, characterData:true});
          } else { // put it there
          $('<crack>Is this for you or a gift?</crack>').insertAfter('div.quick-search__bar'); // do it
          } 
        } // END URN 

        else {$('crack').remove();}
        
      } // end if search is not empty


  }); // end keyup

  $(document).on('click','button.quick-search__clear', function(){
    //console.log('search is cleared');
    $('crack').remove();
  });

//  ░█████╗░██████╗░░█████╗░██╗░░░██╗████████╗
//  ██╔══██╗██╔══██╗██╔══██╗██║░░░██║╚══██╔══╝
//  ███████║██████╦╝██║░░██║██║░░░██║░░░██║░░░
//  ██╔══██║██╔══██╗██║░░██║██║░░░██║░░░██║░░░
//  ██║░░██║██████╦╝╚█████╔╝╚██████╔╝░░░██║░░░
//  ╚═╝░░╚═╝╚═════╝░░╚════╝░░╚═════╝░░░░╚═╝░░░

// IMPORTANT!  TO UPDATE ABOUT PAGE USE TEMPLATE > PAGE.ABOUT.JSON FOR SOME REASON!

  if (window.location.pathname.replace(/\/$/, '') === "/pages/about") {

    var aboutPage = function () {

      console.log('now');
      
      // IMAGE MAP
      $('div.image-with-text__image img').replaceWith("<section id='click' style='overflow:hidden'></section>");
      $('section#click').append(
        '<?xml version="1.0" encoding="UTF-8"?>'+
        '<svg style="width:100%" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1000 1000">'+
        '<style>.image-mapper-shape {fill: rgba(0, 0, 0, 0);}</style>'+
        '<image xlink:href="https://cdn.shopify.com/s/files/1/0101/9278/1369/files/about_photo_-_new.png" style="width: 1000px;"></image>'+
        '<a xlink:href="#" target="---" xlink:title=""><g><polygon points="340,633 368,612 473,387 472,338 530,332 537,410 552,458 562,410 593,380 598,300 600,265 633,242 670,248 695,285 713,355 747,370 767,422 842,565 813,565 757,512 683,580 497,643 455,668 453,720 405,858 400,920 357,930 285,928 337,867 373,770 398,645 402,617 348,647" class="image-mapper-shape" data-index="1"></polygon></g></a>'+
        '</svg>'
      )

      // ERRORS

      // put em there
      $('html').prepend('<alert id="alert"><alert-head id="header">Error<close>x</close></alert-head><i class="fa-solid fa-triangle-exclamation"></i><text><it>Tempted?</it><button>YES</button></text></alert><audiocontrols><sourcesrc="https://cdn.shopify.com/s/files/1/0101/9278/1369/files/error.ogg"type="audio/ogg"><sourcesrc="https://cdn.shopify.com/s/files/1/0101/9278/1369/files/error.mp3"type="audio/mpeg"></audio>');

      // audio
      if (! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        var errorSound = document.createElement('audio');
        errorSound.setAttribute('src', 'https://cdn.shopify.com/s/files/1/0101/9278/1369/files/error.mp3');
      }
      
      // close em
      $(document).on('click','alert close, alert button', function(){
        $('alert').hide();
      })

      // random placement
      function placeEm() {
        
        // desktop placement
        if (! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          var top = Math.floor(Math.random() * 23) + 10;
          var left = Math.floor(Math.random() * 30) + 35;
          $('alert').css({
            'top':top+'%',
            'left':left+'%'
          })
        } // end desktop placement

        // mobile placement
        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          var top = Math.floor(Math.random() * 40) + 5;
          var left = Math.floor(Math.random() * 35) + 32;
          $('alert').css({
            'top':top+'%',
            'left':left+'%'
          })
        } // end mobile placement
      } // end placeEm()
      
      $(document).on('click','g',function(){
        event.preventDefault();
        if ($('#alert:visible').length == 0) { // if not already there
          placeEm();
          $('alert text it').text("Tempted?");
          if (! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {errorSound.play();}
          $('alert').show();
        }
      })

      // Make the DIV element draggable:
      if (! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      dragElement(document.getElementById("alert"));
      
      function dragElement(elmnt) {
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (document.getElementById(elmnt.id + "header")) {
          // if present, the header is where you move the DIV from:
          document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
        } else {
          // otherwise, move the DIV from anywhere inside the DIV:
          elmnt.onmousedown = dragMouseDown;
        }
      
        function dragMouseDown(e) {
          e = e || window.event;
          e.preventDefault();
          // get the mouse cursor position at startup:
          pos3 = e.clientX;
          pos4 = e.clientY;
          document.onmouseup = closeDragElement;
          // call a function whenever the cursor moves:
          document.onmousemove = elementDrag;
        }
      
        function elementDrag(e) {
          e = e || window.event;
          e.preventDefault();
          // calculate the new cursor position:
          pos1 = pos3 - e.clientX;
          pos2 = pos4 - e.clientY;
          pos3 = e.clientX;
          pos4 = e.clientY;
          // set the element's new position:
          elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
          elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }
      
        function closeDragElement() {
          // stop moving when mouse button is released:
          document.onmouseup = null;
          document.onmousemove = null;
        }
      } // end make draggable
      } // end if not mobile
    
    }; // end aboutPage

    if (document.readyState === 'complete') { aboutPage(); }
    else { window.addEventListener('load', aboutPage); }
    
  } // end if about page


//██████╗░██╗░░░░░███████╗░█████╗░░██████╗███████╗  ░██╗░░░░░░░██╗░█████╗░██╗░░██╗███████╗  ██╗░░░██╗██████╗░
//██╔══██╗██║░░░░░██╔════╝██╔══██╗██╔════╝██╔════╝  ░██║░░██╗░░██║██╔══██╗██║░██╔╝██╔════╝  ██║░░░██║██╔══██╗
//██████╔╝██║░░░░░█████╗░░███████║╚█████╗░█████╗░░  ░╚██╗████╗██╔╝███████║█████═╝░█████╗░░  ██║░░░██║██████╔╝
//██╔═══╝░██║░░░░░██╔══╝░░██╔══██║░╚═══██╗██╔══╝░░  ░░████╔═████║░██╔══██║██╔═██╗░██╔══╝░░  ██║░░░██║██╔═══╝░
//██║░░░░░███████╗███████╗██║░░██║██████╔╝███████╗  ░░╚██╔╝░╚██╔╝░██║░░██║██║░╚██╗███████╗  ╚██████╔╝██║░░░░░
//╚═╝░░░░░╚══════╝╚══════╝╚═╝░░╚═╝╚═════╝░╚══════╝  ░░░╚═╝░░░╚═╝░░╚═╝░░╚═╝╚═╝░░╚═╝╚══════╝  ░╚═════╝░╚═╝░░░░░

$(window).on('load', function () {

  //console.log('window load');
  //$('body').prepend('<please id="please">Please wake up</please>');  // for testing

  $('head').append('<style pleasewakeup></syle>');
  rotate_that=true;
  
  function PleaseWakeUp() {

      console.log('please wake up');

      //var scrollpos = $(window).scrollTop();
      //var bottompos = window.scrollY + window.innerHeight;     
      if ($('please')[0]) {$('please').remove();}

      // desktop
        // put it desktop
        if (! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          var top = Math.floor(Math.random() * 45) + 10;
          var left = Math.floor(Math.random() * 45) + 10;
        }
        // put it mobile
        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
          var top = Math.floor(Math.random() * 45) + 15;
          var left = Math.floor(Math.random() * 25) + 5;
        }
          
        var rotate = Math.floor(Math.random() * 15) + 5;
        rotate_that=!rotate_that;
        if (rotate_that == true) {var plusminus = '+'} else {var plusminus = '-'};

        //console.log(rotate_that);
        $('head style[pleasewakeup]').append('<style>please {top:'+top+'%;left:'+left+'%;transform:rotate('+plusminus+rotate+'deg);</style>');
        $('body').prepend('<please id="please">Please wake up</please>');
        
      
      
  } //end PleaseWakeUp();

// get current timer from session
var wakeupsesh = parseInt(sessionStorage.getItem('wakeup'));
//console.log('wakeupsesh='+wakeupsesh);
i=wakeupsesh;
  
setInterval(function(){
  var wakeupsesh = parseInt(sessionStorage.getItem('wakeup'));
  i=wakeupsesh;  
  
  if (i < 600000) {i=i+1000;}
  if (i == 600000) {PleaseWakeUp(); i=0}
  if (i > 600000) {i=0;}  

//  if (i < 15000) {i=i+1000;} // for testing
//  if (i == 15000) {PleaseWakeUp(); i=0} // for testing
//  if (i > 15000) {i=0;}  // for testing
  
  if (i !== i) {i=0}
  sessionStorage.setItem('wakeup',i);
},1000);


}); // end please document ready

var browser = navigator.userAgent;
console.log(browser);
if (browser.indexOf('Ddg')>0) {
  $('body').addClass('ddg');
  console.log('duckduckgo');
} else {console.log('nope');}


//██████╗░███████╗██╗░░░░░███████╗████████╗███████╗  ██████╗░███████╗██╗░░░░░░█████╗░░██╗░░░░░░░██╗  ████████╗░█████╗░
//██╔══██╗██╔════╝██║░░░░░██╔════╝╚══██╔══╝██╔════╝  ██╔══██╗██╔════╝██║░░░░░██╔══██╗░██║░░██╗░░██║  ╚══██╔══╝██╔══██╗
//██║░░██║█████╗░░██║░░░░░█████╗░░░░░██║░░░█████╗░░  ██████╦╝█████╗░░██║░░░░░██║░░██║░╚██╗████╗██╔╝  ░░░██║░░░██║░░██║
//██║░░██║██╔══╝░░██║░░░░░██╔══╝░░░░░██║░░░██╔══╝░░  ██╔══██╗██╔══╝░░██║░░░░░██║░░██║░░████╔═████║░  ░░░██║░░░██║░░██║
//██████╔╝███████╗███████╗███████╗░░░██║░░░███████╗  ██████╦╝███████╗███████╗╚█████╔╝░░╚██╔╝░╚██╔╝░  ░░░██║░░░╚█████╔╝
//╚═════╝░╚══════╝╚══════╝╚══════╝░░░╚═╝░░░╚══════╝  ╚═════╝░╚══════╝╚══════╝░╚════╝░░░░╚═╝░░░╚═╝░░  ░░░╚═╝░░░░╚════╝░

//████████╗██╗░░░██╗██████╗░███╗░░██╗  ░█████╗░███████╗███████╗
//╚══██╔══╝██║░░░██║██╔══██╗████╗░██║  ██╔══██╗██╔════╝██╔════╝
//░░░██║░░░██║░░░██║██████╔╝██╔██╗██║  ██║░░██║█████╗░░█████╗░░
//░░░██║░░░██║░░░██║██╔══██╗██║╚████║  ██║░░██║██╔══╝░░██╔══╝░░
//░░░██║░░░╚██████╔╝██║░░██║██║░╚███║  ╚█████╔╝██║░░░░░██║░░░░░
//░░░╚═╝░░░░╚═════╝░╚═╝░░╚═╝╚═╝░░╚══╝  ░╚════╝░╚═╝░░░░░╚═╝░░░░░

//██████╗░███████╗███████╗░█████╗░██╗░░░██╗██╗░░░░░████████╗  ███████╗███╗░░░███╗░█████╗░██████╗░███████╗
//██╔══██╗██╔════╝██╔════╝██╔══██╗██║░░░██║██║░░░░░╚══██╔══╝  ██╔════╝████╗░████║██╔══██╗██╔══██╗██╔════╝
//██║░░██║█████╗░░█████╗░░███████║██║░░░██║██║░░░░░░░░██║░░░  █████╗░░██╔████╔██║██║░░██║██║░░██║█████╗░░
//██║░░██║██╔══╝░░██╔══╝░░██╔══██║██║░░░██║██║░░░░░░░░██║░░░  ██╔══╝░░██║╚██╔╝██║██║░░██║██║░░██║██╔══╝░░
//██████╔╝███████╗██║░░░░░██║░░██║╚██████╔╝███████╗░░░██║░░░  ███████╗██║░╚═╝░██║╚█████╔╝██████╔╝███████╗
//╚═════╝░╚══════╝╚═╝░░░░░╚═╝░░╚═╝░╚═════╝░╚══════╝░░░╚═╝░░░  ╚══════╝╚═╝░░░░░╚═╝░╚════╝░╚═════╝░╚══════╝


